// Feature flags for optional backend integration
// When backend is ready, set ENABLE_REMOTE_SYNC to true and provide API_BASE_URL

export const FEATURES = {
  // Remote sync: disabled by default (app works 100% locally)
  // Enable this when a real backend is available
  ENABLE_REMOTE_SYNC: process.env.NEXT_PUBLIC_ENABLE_REMOTE_SYNC === 'true',

  // API base URL (only used if ENABLE_REMOTE_SYNC is true)
  API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL ?? '',
} as const;

// Helper to check if remote sync is available
export function isRemoteSyncEnabled(): boolean {
  return FEATURES.ENABLE_REMOTE_SYNC && Boolean(FEATURES.API_BASE_URL);
}
